// extracted by mini-css-extract-plugin
export default {"card":"Card_card__fzgN8","interactive":"Card_interactive__AOk66","accent":"Card_accent__w22tm"};